import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/closed-loop.html";

import LanguageManager from "Sources/services/language-manager";

const infoIcons = require.context("!raw-loader!Images/info", false, /\.svg$/);

require("Styles/components/popup/closed-loop.scss");

class ClosedLoopView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.type = options.type;
        this.points = options.points;

        let awardTypeImage = options.html.find(".award-type-image");
        if (awardTypeImage)
        {
            if (this.type === "product_refurbishing")
            {
                awardTypeImage.html(infoIcons("./award_reuse.svg"));
            }
            else if (this.type === "repair_workshop")
            {
                awardTypeImage.html(infoIcons("./award_renting.svg"));
            }
            else
            {
                awardTypeImage.html(infoIcons("./award_production.svg"));
            }
            LanguageManager.applyLocale(awardTypeImage);
        }

        options.html.find(".award-points-text").text(this.points);

        switch (this.type)
        {
            case "product_refurbishing":
                options.html.find(".popup-title").html(LanguageManager.getValueForKey("investment.closed_loop.refurbish.title"));
                options.html.find(".popup-message").html(LanguageManager.getValueForKey("investment.closed_loop.refurbish"));
                break;
            case "repair_workshop":
                options.html.find(".popup-title").html(LanguageManager.getValueForKey("investment.closed_loop.repair.title"));
                options.html.find(".popup-message").html(LanguageManager.getValueForKey("investment.closed_loop.repair"));
                break;
            default:
                options.html.find(".popup-title").html(LanguageManager.getValueForKey("investment.efficient_production.title"));
                options.html.find(".popup-message").html(LanguageManager.getValueForKey("investment.efficient_production.production"));
                break;
        }

        options.html.find(".popup-message").text(options.html.find(".popup-message").text().replace("{points}", this.points));
    }
}

module.exports = ClosedLoopView;


// WEBPACK FOOTER //
// ./app/js/components/popup/closed-loop.js